import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';

/**
 * SummaryCard - Individual summary card component
 */
function SummaryCard({ title, value, icon, iconColor, iconBg }) {
  return (
    <Card
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        p: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        transition: 'box-shadow 0.2s ease',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 500, mb: 0.5, fontSize: '0.8125rem' }}
          >
            {title}
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, fontSize: '2rem', color: 'text.primary', lineHeight: 1 }}
          >
            {value}
          </Typography>
        </Box>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: '10px',
            bgcolor: iconBg,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          {React.cloneElement(icon, { sx: { color: iconColor, fontSize: 22 } })}
        </Box>
      </Box>
    </Card>
  );
}

/**
 * SummaryCards - 4 summary cards at the top of the patients page
 * @param {Object} props
 * @param {number} props.totalPatients - Pessoas cadastradas (sem os excluídos), contadas no servidor
 * @param {number} props.activePatients - Quantas estão ativas
 */
function SummaryCards({ totalPatients = 0, activePatients = 0 }) {
  const isMobile = useMediaQuery('(max-width: 760px)');

  const cards = [
    {
      title: 'Total de pacientes',
      value: totalPatients,
      icon: <PeopleOutlinedIcon />,
      iconColor: '#5A80FB',
      iconBg: 'rgba(90, 128, 251, 0.1)',
    },
    {
      title: 'Pacientes ativos',
      value: activePatients,
      icon: <FavoriteBorderOutlinedIcon />,
      iconColor: '#ED3680',
      iconBg: 'rgba(237, 54, 128, 0.1)',
    },
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
        gap: 2,
        mb: 3,
      }}
    >
      {cards.map((card, index) => (
        <SummaryCard key={index} {...card} />
      ))}
    </Box>
  );
}

export default SummaryCards;
